import { render } from "./RemoveModal.vue?vue&type=template&id=1d1ed3ee&scoped=true"
import script from "./RemoveModal.vue?vue&type=script&lang=js"
export * from "./RemoveModal.vue?vue&type=script&lang=js"

import "./RemoveModal.vue?vue&type=style&index=0&id=1d1ed3ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d1ed3ee"],['__file',"src/components/RemoveModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1d1ed3ee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1d1ed3ee', __exports__)) {
    api.reload('1d1ed3ee', __exports__)
  }
  
  module.hot.accept("./RemoveModal.vue?vue&type=template&id=1d1ed3ee&scoped=true", () => {
    api.rerender('1d1ed3ee', render)
  })

}


export default __exports__